export const PROVIDER_ORDER = ["anthropic", "google", "openai", "xai", "dochat"];
export const MENU_WIDTH = 240;
export const MENU_GAP = 8;
export const ROW_MIN_HEIGHT = 36;
export const MENU_PADDING = 6;
